import { render, staticRenderFns } from "./View.vue?vue&type=template&id=5f007670&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=5f007670&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f007670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f007670')) {
      api.createRecord('5f007670', component.options)
    } else {
      api.reload('5f007670', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=5f007670&scoped=true", function () {
      api.rerender('5f007670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/pcgoodslist/View.vue"
export default component.exports